module.exports = __webpack_public_path__ + "static/media/sunrise-weather_200_transparent.33fbbfb4.gif";